import React, { useState, useRef } from 'react';
import { Captcha, CaptchaHandle } from '../../components/Captcha';
const PROGRAM_OPTIONS = ['Mini Troopers', 'Kids Taekwondo', 'Family Classes', 'Competition Team', 'Summer Camp', 'General Question'];
interface FieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
}
function Field({
  id,
  label,
  ...rest
}: FieldProps) {
  return <div data-id="element-1929">
      <label htmlFor={id} className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1930">
        {label}
      </label>
      <input id={id} name={id} className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" {...rest} data-id="element-1931" />
    </div>;
}
export function KidsHeroForm() {
  const [captchaValid, setCaptchaValid] = useState(false);
  const captchaRef = useRef<CaptchaHandle>(null);
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-1932">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-1933">
        Find the Right Kids Class
      </div>

      <form action="/thank-you-free-trial" method="get" className="mt-4 flex flex-col gap-5" data-id="element-1934">
        <Field id="parentName" label="Parent / Guardian Name" type="text" required autoComplete="name" placeholder="Parent or Guardian Name" data-id="element-1935" />
        <Field id="phone" label="Phone Number" type="tel" required autoComplete="tel" placeholder="(517) 220-0621" data-id="element-1936" />
        <Field id="email" label="Email Address" type="email" required autoComplete="email" placeholder="email@example.com" data-id="element-1937" />
        <Field id="childAge" label="Child's Age" type="number" inputMode="numeric" min={3} max={17} required placeholder="e.g. 6" data-id="element-1938" />

        <div data-id="element-1939">
          <label htmlFor="interestedIn" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1940">
            Interested In
          </label>
          <select id="interestedIn" name="interestedIn" required defaultValue="Kids Taekwondo" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" data-id="element-1941">
            {PROGRAM_OPTIONS.map(opt => <option key={opt} value={opt} data-id="element-1942">
                {opt}
              </option>)}
          </select>
        </div>

        <Captcha ref={captchaRef} onValidChange={setCaptchaValid} data-id="element-1943" />

        <button type="submit" disabled={!captchaValid} className="btn-primary w-full disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-1944">
          Check Class Availability
        </button>

        <p className="text-xs text-gray-warm text-center leading-relaxed" data-id="element-1945">
          We will help you choose the right starting class based on your child's
          age and goals.
        </p>
      </form>
    </div>;
}